const READABLE_PROTOCOLS = ['http:', 'https:'];
const VOOMA_OWNED_HOSTNAMES = [
  'app.vooma.ai',
  'vooma.ai',
  'vooma.com',
  'vooma-clerk-staging.com',
];

export function normalizeDomain(domain: string): string {
  const value = domain.trim();
  if (!value) return '';

  try {
    const url = new URL(value.includes('://') ? value : `https://${value}`);
    if (!READABLE_PROTOCOLS.includes(url.protocol)) return '';
    return normalizeHostname(url.hostname);
  } catch {
    return '';
  }
}

export function getPageHostname(pageUrl: string): string | null {
  try {
    const url = new URL(pageUrl);
    if (!READABLE_PROTOCOLS.includes(url.protocol)) return null;
    return normalizeHostname(url.hostname) || null;
  } catch {
    return null;
  }
}

function normalizeHostname(hostname: string): string {
  return hostname
    .toLowerCase()
    .replace(/^www\./, '')
    .replace(/\.$/, '');
}

export function isHostnameCoveredByDomain(
  hostname: string,
  domain: string
): boolean {
  return hostname === domain || hostname.endsWith(`.${domain}`);
}

export function isDomainAllowed(
  hostname: string,
  allowedDomains: string[]
): boolean {
  const normalizedHostname = normalizeDomain(hostname);
  return allowedDomains
    .map(normalizeDomain)
    .some(
      (domain) =>
        domain.length > 0 &&
        isHostnameCoveredByDomain(normalizedHostname, domain)
    );
}

export function isVoomaOwnedDomain(hostname: string): boolean {
  return VOOMA_OWNED_HOSTNAMES.includes(normalizeDomain(hostname));
}

export function addAllowedDomain(
  allowedDomains: string[],
  hostname: string
): string[] {
  const normalizedHostname = normalizeDomain(hostname);
  return !normalizedHostname ||
    isDomainAllowed(normalizedHostname, allowedDomains)
    ? allowedDomains
    : [...allowedDomains, normalizedHostname];
}
